import { render, staticRenderFns } from "./VueUploadAvatar.vue?vue&type=template&id=033618d2"
import script from "./VueUploadAvatar.vue?vue&type=script&lang=js"
export * from "./VueUploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./VueUploadAvatar.vue?vue&type=style&index=0&id=033618d2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports